import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import i18n from './i18n'
import router from './router'
import VueApexCharts from 'vue3-apexcharts'
import ClickOutside from './components/ui/ClickOutside'
import './style.css'
//import './assets/main.css'
// import 'lineicons/dist/lineicons.css'

// Suppressions liées à vue-unicons
// import Unicon from 'vue-unicons'
// import { uniApps, uniArchive } from 'vue-unicons/dist/icons'

// Unicon.add([uniApps, uniArchive])

const app = createApp(App)
app.use(createPinia())
app.use(i18n)
app.use(router)
// app.use(Unicon) // Suppression de l'utilisation du plugin
app.component('apexchart', VueApexCharts)
app.directive('click-outside', ClickOutside)
app.mount('#app')

if (window.location.protocol === 'http:' && !window.location.hostname.includes('localhost')) {
  window.location.href = window.location.href.replace('http:', 'https:');
}